import { useAuth } from '@/contexts/AuthContext';
import { convertWeight } from './volumeCalc';

/**
 * Round a number to at most `decimals` decimal places.
 * Strips trailing zeros: 102.10 → 102.1, 225.00 → 225
 */
export function roundDisplay(value: number, decimals = 2): number {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}

export function useUnits() {
  const { profile } = useAuth();
  const userUnits = profile?.units ?? 'lbs';
  
  /** Convert a weight value for display, rounded to 2 decimals. sourceUnit defaults to 'lbs' if unknown. */
  const displayWeight = (value: number, sourceUnit?: string): number => {
    const raw = convertWeight(value, sourceUnit ?? 'lbs', userUnits);
    return roundDisplay(raw);
  };
  
  /** Format weight with unit label, rounded to 1 decimal */
  const formatWeight = (value: number, sourceUnit?: string): string => {
    const converted = displayWeight(value, sourceUnit);
    return `${roundDisplay(converted, 1)} ${userUnits}`;
  };
  
  /** Just the unit label */
  const unitLabel = userUnits;
  
  return { displayWeight, formatWeight, unitLabel, userUnits, roundDisplay };
}